import { render } from "./ListTaxAddressModal.vue?vue&type=template&id=1fcf90da&scoped=true"
import script from "./ListTaxAddressModal.vue?vue&type=script&lang=js"
export * from "./ListTaxAddressModal.vue?vue&type=script&lang=js"

import "./ListTaxAddressModal.vue?vue&type=style&index=0&id=1fcf90da&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fcf90da"]])

export default __exports__